var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "calendar_svg__Layer_1",
    viewBox: "0 0 18.6 18.1",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".calendar_svg__cls-1{fill:#231f20}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.88.66h16.85v1.72H.88zM17.72 4.1H.88v13.13h16.84zM8.48 9.72v1.99H6.49V9.72zM6.49 7.91V5.83h1.99v2.08zm1.99 5.53v2.08H6.49v-2.08zm1.72 0h1.99v2.08H10.2zm0-1.72V9.73h1.99v1.99zm0-3.8V5.84h1.99v2.08zm-7.6-2.1h2.08V7.9H2.6zm0 3.89h2.08v1.99H2.6zm0 3.71h2.08v2.08H2.6zm13.32 2.08h-1.99v-2.08h1.99zm0-3.8h-1.99V9.71h1.99zm-1.99-3.8V5.82h1.99V7.9z",
    className: "calendar_svg__cls-1"
  })));
};
export default SvgCalendar;